// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__LFhQWzjk7E{display:flex;align-items:center}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/header/toolbar/conversationToolbar.module.scss"],"names":[],"mappings":"AAEA,kBACE,YAAA,CACA,kBAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.root {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__LFhQWzjk7E`
};
export default ___CSS_LOADER_EXPORT___;
